import { joinInfoMeta } from './joinMetaInfo.js';
import { parseData } from './parseData';
import { parseIntegrals } from './parseIntegrals.js';
import { setFIDSpectrumData } from './setFIDSpectrumData';
import { setProcessedSpectrumData } from './setProcessedSpectrumData';

export async function convert1D(files, options) {
  const data = {};
  const promises = [];
  const filesToRead = files['1r'] || files['1i'] ? ['1r', '1i'] : ['fid'];
  for (const key of filesToRead) {
    if (!files[key]) continue;
    promises.push(files[key].arrayBuffer().then((r) => (data[key] = r)));
  }
  promises.push(parseData(files.procs, options).then((r) => (data.procs = r)));
  promises.push(parseData(files.acqus, options).then((r) => (data.acqus = r)));

  if (files.quantFactorSample) {
    promises.push(getEreticFactor(files).then((r) => (data.ereticFactor = r)));
  }
  if (files.integrals) {
    promises.push(parseIntegrals(files).then((r) => (data.integrals = r)));
  }

  await Promise.allSettled(promises);
  return formatSpectrum(data);
}

function formatSpectrum(data) {
  const { procs: result, acqus, integrals, ereticFactor } = data;
  joinInfoMeta(result, acqus);

  if (integrals) {
    result.integrals = integrals;
  }
  if (ereticFactor) {
    result.info.ereticFactor = ereticFactor;
  }
  if (data['1r'] || data['1i']) {
    setProcessedSpectrumData(
      {
        re: data['1r'],
        im: data['1i'],
      },
      result,
    );
  } else if (data.fid) {
    setFIDSpectrumData(data.fid, result);
  }

  return result;
}

async function getEreticFactor(files) {
  const quantFactorSample = (await files.quantFactorSample.text()).match(
    /<Application[\w\W]+<Eretic_Factor>(?<ereticFactor>[\d.]+)/,
  );
  return Number(quantFactorSample.groups.ereticFactor);
}
